import image1 from "../../assets/blog-01.jpg";
import image2 from "../../assets/blog-02.jpg";
import image3 from "../../assets/blog-03.jpg";

export const LATESTBLOG = [
  {
    id: 1,
    image: image1,
    date: "By Nancy Ward on July 22, 2022",
    title: "Resident Evil Village DLC Winters’ Expansion launches October 28",
  },
  {
    id: 2,
    image: image2,
    date: "By Nancy Ward on July 22, 2022",
    title: "The Witcher 3. Meaning of all this simbols",
    className: "image2",
  },
  {
    id: 3,
    image: image3,
    date: "By Nancy Ward on July 22, 2022",
    title:
      "Players’ Choice: Final Fantasy VII Remake Voted April’s Best New Game",
  },
];
